export enum EventType {
  errorViewErrorMessage = 'errorViewErrorMessage',
  startStart = 'startStart',
  startSelectRetirementType = 'startSelectRetirementType',
  startSelectPath = 'startSelectPath',
  startSelectGoal = 'startSelectGoal',
  riskprofilerClickExpand = 'riskprofilerClickExpand',
  riskprofilerComplete = 'riskprofilerComplete',
  productClickSetQuota = 'productClickSetQuota',
  productRemove = 'productRemove',
  productAddToCart = 'productAddToCart',
  productViewPopup = 'productViewPopup',
  productClosePopup = 'productClosePopup',
  productChangeDatePeriod = 'productChangeDatePeriod',
  productChangeDuration = 'productChangeDuration',
  productClickUnitPrice = 'productClickUnitPrice',
  productDownload = 'productDownload',
  expertStart = 'expertStart',
  expertViewProductList = 'expertViewProductList',
  expertStartSearch = 'expertStartSearch',
  expertSearch = 'expertSearch',
  expertSetInvestmentType = 'expertSetInvestmentType',
  expertSetInvestmentHorizon = 'expertSetInvestmentHorizon',
  expertSetFundType = 'expertSetFundType',
  expertSetUmbrella = 'expertSetUmbrella',
  expertSetRiskType = 'expertSetRiskType',
  expertSetROI = 'expertSetROI',
  preferenceStart = 'preferenceStart',
  preferenceSubmitBudget = 'preferenceSubmitBudget',
  preferenceStartRiskProfiler = 'preferenceStartRiskProfiler',
  preferenceSubmitRiskLevel = 'preferenceSubmitRiskLevel',
  preferenceClickSeeMore = 'preferenceClickSeeMore',
  preferenceClickChangeBudget = 'preferenceClickChangeBudget',
  setquotaBack = 'setquotaBack',
  setquotaView = 'setquotaView',
  setquotaSubmit = 'setquotaSubmit',
  setquotaEditBudget = 'setquotaEditBudget',
  registrationStart = 'registrationStart',
  registrationEditQuota = 'registrationEditQuota',
  registrationSelectMore = 'registrationSelectMore',
  registrationSubmitBasicData = 'registrationSubmitBasicData',
  registrationSubmitContact = 'registrationSubmitContact',
  registrationSubmitPersonalData = 'registrationSubmitPersonalData',
  registrationSubmitSurvey = 'registrationSubmitSurvey',
  registrationEdit = 'registrationEdit',
  registrationComplete = 'registrationComplete',
  registrationDownload = 'registrationDownload',
  registrationResendSMS = 'registrationResendSMS',
  registrationSubmitSummary = 'registrationSubmitSummary',
  verificationStart = 'verificationStart',
  verificationSendSMS = 'verificationSendSMS',
  verificationStartDesktop = 'verificationStartDesktop',
  verificationStartMobile = 'verificationStartMobile',
  verificationComplete = 'verificationComplete',

  viewItemList = 'view_item_list',
  selectItem = 'select_item',
  addToCart = 'add_to_cart',
  removeFromCart = 'remove_from_cart',
  viewItem = 'view_item',
  purchase = 'purchase',
  viewCart = 'view_cart'
}
